var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"li-us-glosary-title openSans-400 fz-19"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"li-us-glosary-description openSans-100 fz-17"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }